export default {
    lists: [
        // '/',
        // '/index',
        // '/distribution/chat',
        '/distribution/examination/index',
        '/school/course_details',
        '/school/course_info',
        '/school/course_list',
        '/college/index',
        '/school/course_list',
        '/School_business',
        '/school_business',
        '/sharedetail',
        '/login',
        '/register',
        '/register_audit',
        '/bind_wechat',
        '/goodsdetail_share',
        '/distribution/help/details',
        '/yunindex',
        '/tourists/index',
        '/tourists/course/qrcode',
        '/retail/special/list',
        '/retail/special/details',
        '/retail/special/details2',
        // '/tourists/course/detail',
        '/tourists/personal_center',
        '/tourists/goodsdetail',
        '/download',
        '/download_shop',
        '/tourists/index',
        '/distribution/wallet/qrcode',
        "/distribution/shoporder/qrcode",
        '/agreement',
        '/scaleusercompinfo',
        '/notice',
    ],
    isUrl: function(url, type) {
        let sym = '==';
        if (type) {
            sym = type;
        }
        let that = this;
        let noLoginUrls = '';
        for (var i = 0; i < that.lists.length; i++) {
            if (i == 0) {
                noLoginUrls += '"' + url + '"' + sym + '"' + that.lists[i] + '"';
            } else {
                noLoginUrls += '||' + '"' + url + '"' + sym + '"' + that.lists[i] + '"';
            }
        }
        return eval(noLoginUrls);
    }
}


// WEBPACK FOOTER //
// ./src/routes/nologin.js